import { render, staticRenderFns } from "./msgrsList.vue?vue&type=template&id=51d87d69&"
import script from "./msgrsList.vue?vue&type=script&lang=ts&"
export * from "./msgrsList.vue?vue&type=script&lang=ts&"
import style0 from "./msgrsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports